import React from 'react';
import { Card } from 'react-bootstrap';
import Avatar from 'components/common/Avatar';
import DirectoryService from 'components/app/directory/DirectoryService';
import { useEffect } from 'react';
const formatBirthdayDate = date => {
  if (!date) return '';

  const [day, month, year] = date.split('/');

  const parsedDate = new Date(year, month - 1, day);

  return parsedDate.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short'
  });
};

const UpcomingBirthdaysCard = () => {
  const [data, setData] = React.useState([]);
  useEffect(() => {
    DirectoryService.retrieveUpcomingBirthdays()
      .then(data => {
        console.log('Upcoming birthdays data:', data);
        const updatedData = data.slice(0, 4).map(member => ({
          ...member,
        }));
        setData(updatedData);
      })
      .catch(error => {
        console.error('Error retrieving upcoming birthdays:', error);
      });
  }, []);
  return (
    <Card className="h-100 border-0 shadow-sm">
      <Card.Body>
        <h6 className="mb-3">Upcoming Birthdays</h6>
        {data?.length === 0 && (
          <p className="text-body-tertiary mb-0">
            No upcoming birthdays to show.
          </p>
        )}
        <div className="d-flex flex-column gap-3">
          {data?.map(member => (
            <div key={member.identifier} className="d-flex align-items-center">
              <Avatar
                src={member.avatar}
                name={member.firstName + ' ' + member.lastName}
                size="l"
                className="me-3"
              />
              <span className="fw-semibold">
                {member.firstName} {member.lastName} {formatBirthdayDate(member.dob)}
              </span>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default UpcomingBirthdaysCard;
